import { Component, createRef } from "react";
import { NSBox, NSBoxBoolean, NSBoxEnum, NSBoxInteger, NSBoxString, NSBoxTextArea, NSColumn, NSRow } from "namirasoft-site-react";
import { NSARouterMakerProps } from "namirasoft-account-react";
import { TopicDelayUnit, TopicInputRow, TopicLimitPerUnit, TopicRow } from "namirasoft-notification-sender";
import { NotificationSenderProps } from "../NotificationSenderProps";
import { NotificationSenderLayout } from "../NotificationSenderLayout";
import { NotificationSenderEntity } from "../NotificationSenderEntity";

export interface TopicEditPageProps extends NSARouterMakerProps, NotificationSenderProps
{
	isEdit: boolean;
}

export default class TopicEditPage extends Component<TopicEditPageProps>
{
	private NSBoxString_Name = createRef<NSBoxString>();
	private NSBoxBoolean_Limit = createRef<NSBoxBoolean>();
	private NSBoxInteger_Limit_Count = createRef<NSBoxInteger>();
	private NSBoxInteger_Limit_Per_Value = createRef<NSBoxInteger>();
	private NSBoxEnum_Limit_Per_Unit = createRef<NSBoxEnum<TopicLimitPerUnit>>();
	private NSBoxBoolean_Delay = createRef<NSBoxBoolean>();
	private NSBoxInteger_Delay_Value = createRef<NSBoxInteger>();
	private NSBoxEnum_Delay_Unit = createRef<NSBoxEnum<TopicDelayUnit>>();
	private NSBoxTextArea_Description = createRef<NSBoxTextArea>();

	constructor(props: TopicEditPageProps)
	{
		super(props);
		this.state = {};
	}
	override render()
	{
		let extra_tabs = [];
		extra_tabs.push(
			{
				title: "Limit",
				clicked: true,
				getContent: () =>
				{
					return (
						<NSColumn style={{ width: NSBox.width.double }}>
							<NSRow>
								<NSBoxBoolean
									ref={this.NSBoxBoolean_Limit}
									title="Limit"
									required
									style={{ width: "100%" }}
									defaultValue={false}
									onChanged={() => this.setState({})}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Count}
									title="Limit Count"
									required
									min={0}
									style={{ width: "100%" }}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Limit.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Limit_Per_Value}
									title="Limit Per Value"
									required
									min={1}
								/>
								<NSBoxEnum<TopicLimitPerUnit>
									ref={this.NSBoxEnum_Limit_Per_Unit}
									title="Limit Per Unit"
									required
									multiple={false}
									getEnumObject={() => TopicLimitPerUnit}
								/>
							</NSRow>
						</NSColumn>
					);
				}
			},
			{
				title: "Delay",
				clicked: true,
				getContent: () =>
				{
					return (
						<NSColumn style={{ width: NSBox.width.double }}>
							<NSRow>
								<NSBoxBoolean
									ref={this.NSBoxBoolean_Delay}
									title="Delay"
									required
									style={{ width: "100%" }}
									defaultValue={false}
									onChanged={() => this.setState({})}
								/>
							</NSRow>
							<NSRow style={this.NSBoxBoolean_Delay.current?.getValueBool() ? {} : { display: "none" }}>
								<NSBoxInteger
									ref={this.NSBoxInteger_Delay_Value}
									title="Delay Value"
									required
									min={1}
								/>
								<NSBoxEnum<TopicDelayUnit>
									ref={this.NSBoxEnum_Delay_Unit}
									title="Delay Unit"
									required
									multiple={false}
									getEnumObject={() => TopicDelayUnit}
								/>
							</NSRow>
						</NSColumn>
					);
				}
			}
		);

		return (
			<NotificationSenderLayout<TopicRow, TopicInputRow>
				{...this.props}
				pages={{
					entity: NotificationSenderEntity.Topic(this.props),
					edit: {
						...this.props,
						ui: {
							tab_page_edit: {
								editor: {
									getInputRow: () =>
									{
										let workspace_id: null = null
										let name: string = this.NSBoxString_Name.current?.getValue() ?? "";

										// Limit
										let limit: boolean = this.NSBoxBoolean_Limit.current?.getValueBool() ?? false;
										let limit_count: number | null = null;
										let limit_per_value: number | null = null;
										let limit_per_unit: TopicLimitPerUnit | null = null;
										if (limit)
										{
											limit_count = this.NSBoxInteger_Limit_Count.current?.getValue() ?? 0;
											limit_per_value = this.NSBoxInteger_Limit_Per_Value.current?.getValue() ?? 0;
											limit_per_unit = this.NSBoxEnum_Limit_Per_Unit.current?.getValueEnumOne(TopicLimitPerUnit, TopicLimitPerUnit.Second) ?? TopicLimitPerUnit.Second;
										}

										// Delay
										let delay: boolean = this.NSBoxBoolean_Delay.current?.getValueBool() ?? false;
										let delay_value: number | null = null;
										let delay_unit: TopicDelayUnit | null = null;
										if (delay)
										{
											delay_value = this.NSBoxInteger_Delay_Value.current?.getValue() ?? 0;
											delay_unit = this.NSBoxEnum_Delay_Unit.current?.getValueEnumOne(TopicDelayUnit, TopicDelayUnit.Second) ?? TopicDelayUnit.Second;
										}

										let description: string = this.NSBoxTextArea_Description.current?.getValue() ?? "";

										return {
											workspace_id,
											name,

											limit,
											limit_count,
											limit_per_value,
											limit_per_unit,

											delay,
											delay_value,
											delay_unit,

											description,

											topic_category: [], topic_field: [], topic_tag: []
										};
									},
									setRow: (row) =>
									{
										this.NSBoxString_Name.current?.setValue(row.name);
										this.NSBoxBoolean_Limit.current?.setValue(row.limit);
										if (row.limit)
										{
											this.NSBoxInteger_Limit_Count.current?.setValue(row.limit_count);
											this.NSBoxInteger_Limit_Per_Value.current?.setValue(row.limit_per_value);
											this.NSBoxEnum_Limit_Per_Unit.current?.setValue(row.limit_per_unit);
										}
										this.NSBoxBoolean_Delay.current?.setValue(row.delay);
										if (row.delay)
										{
											this.NSBoxInteger_Delay_Value.current?.setValue(row.delay_value);
											this.NSBoxEnum_Delay_Unit.current?.setValue(row.delay_unit);
										}
										this.NSBoxTextArea_Description.current?.setValue(row.description ?? "");
									}
								},
								ui: {
									extra_tabs
								}
							}

						},
					},
				}}
			>
				<NSRow>
					<NSBoxString
						ref={this.NSBoxString_Name}
						title="Name"
						required
						style={{ width: "100%" }}
					/>
					<NSBoxTextArea
						ref={this.NSBoxTextArea_Description}
						title="Description"
						required={false}
						rows={5}
						style={{ width: "100%" }}
					/>
				</NSRow>
			</NotificationSenderLayout >
		);
	}
}